import React, { FC, ReactNode } from "react";
import classes from "./floatingLabel.module.css";
import useFloatingLabel from "./useFloatingLabel";
import { setIsEngravingType, setRingOptionsType } from "../../types";
import Icon from "../Icons";

export interface FloatingLabelType {
  label: string;
  maxLength: number;
  labelId: string;
  keyName: string;
  value: string;
  setRingOptions: setRingOptionsType;
  setIsEngraving: setIsEngravingType;
  options: { [key: string]: string };
  activeIndex: number;
  isHandView: boolean;
  validationRegex?: RegExp;
  validationErrorMessage?: string;
}

export interface SimpleFloatingLabelProps {
  label: string;
  value: string;
  onChange: (v: string) => void;
  icon?: ReactNode;
  type?: string;
  inputRef?: React.RefObject<HTMLInputElement>;
}

// Simple standalone floating label — no ring/engraving dependencies
export const SimpleFloatingLabel: FC<SimpleFloatingLabelProps> = ({ label, value, onChange, icon, type = 'text', inputRef }) => (
  <label className={classes.simpleField}>
    {icon && <span className={classes.simpleIcon}>{icon}</span>}
    <div className={classes.simpleInner}>
      <span className={`${classes.simpleLabel} ${value ? classes.simpleLabelActive : ''}`}>
        {label}
      </span>
      <input
        ref={inputRef}
        className={classes.simpleInput}
        type={type}
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder=""
      />
    </div>
  </label>
);

// Original engraving FloatingLabel
const FloatingLabel: FC<FloatingLabelType> = (props) => {
  const {
    options,
    setIsEngraving,
    label,
    labelId,
    maxLength,
    setRingOptions,
    keyName,
    value,
    validationRegex,
    validationErrorMessage,
    ...rest
  } = props;
  const { inputValue, handleChange, handleKeyUp, error } = useFloatingLabel(props);
  return (
    <div className={classes.root}>
      <input
        type="text"
        id={labelId}
        placeholder={label}
        className={`${classes.input}`}
        onChange={handleChange}
        value={value ? value : ""}
        maxLength={maxLength}
        onKeyUp={handleKeyUp}
      />
      <span className={classes.counter}>
        {inputValue.length} / {maxLength}
      </span>
      {error && <span className={classes.errorMessage}><Icon name={'hk_info_circle'} />{error}</span>}
      <label htmlFor={labelId} className={classes.label}>
        {label}
      </label>
    </div>
  );
};

export default FloatingLabel;
